import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {lastValueFrom} from "rxjs";
import {GoldenRecord} from "../Model/goldenRecord";

@Injectable()
export class GoldenRecordService {
  private readonly apiUrl = 'api/GoldenRecord';

  constructor(private http: HttpClient) {}

  public getGoldenRecord(customerId: string): Promise<GoldenRecord> {
    const url = `${this.apiUrl}/getGoldenRecord`;
    const params = new HttpParams().append('customerId', customerId);
    return lastValueFrom(this.http.get<GoldenRecord>(url, { params }));
  }

  public delete(id: string, customerId: string): Promise<void> {
    const url = `${this.apiUrl}/delete`;
    const params = new HttpParams()
      .append('id', id)
      .append('customerId', customerId);
    return lastValueFrom(this.http.delete<void>(url, { params }));
  }

  public promoteBackup(backupId: string, customerId: string): Promise<any> {
    const url = `${this.apiUrl}/promoteBackup`;
    return lastValueFrom(this.http.post(url, {
      backupId,
      customerId,
      restoreMedia: false
    }));
  }
}
